<template>
  <div class="content">
    <el-row type="flex" justify="start">
      <el-col :span="21">
        <el-form
          label-position="top"
          label-width="200px"
          ref="form"
          :rules="rules"
          :model="form"
        >
          <h3>分享奖励</h3>
          <div>
            <el-row type="flex" justify="center">
              <el-col>
                <h3 class="text-center">
                  所有套餐的「现金奖励」和「RP积分奖励」
                </h3>
              </el-col>
            </el-row>

            <el-table
              :data="form.configs"
              border
              style="width: 100%"
              @cell-mouse-enter="handleCellEnter"
              @cell-mouse-leave="handleCellLeave"
            >
              <el-table-column prop="date" label="套餐" width="100">
                <template slot-scope="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column prop="date" label="现金奖励">
                <template slot-scope="scope">
                  <el-input
                    class="item"
                    type="number"
                    v-model="scope.row.money_reward_value"
                    placeholder="请输入正整数"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="RP积分">
                <template slot-scope="scope">
                  <el-input
                    class="item"
                    type="number"
                    v-model="scope.row.rp_reward_value"
                    placeholder="请输入正整数"
                  ></el-input>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="date" label="奖励点数">
                <template slot-scope="scope">
                  <el-input
                    class="item"
                    type="number"
                    v-model="scope.row.vip_point"
                    placeholder="请输入正整数"
                  ></el-input>
                </template>
              </el-table-column> -->
              <!-- <el-table-column prop="date" label="奖励代数">
                <template slot-scope="scope">
                  <el-input
                    class="item"
                    type="number"
                    v-model="scope.row.reward_gene_num"
                    placeholder="请输入正整数"
                  ></el-input>
                </template>
              </el-table-column> -->
              <el-table-column prop="date" label="可获得奖励代数">
                <template slot-scope="scope">
                  <el-input
                    class="item"
                    type="number"
                    v-model="scope.row.can_receive_reward_gene_num"
                    placeholder="请输入正整数"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-col :span="12">
            <h3>建设奖</h3>
            <el-form-item prop="referral_bonus_extra_reward_money_gene_num">
              <el-input
                type="number"
                v-model.number="form.referral_bonus_extra_reward_money_gene_num"
                placeholder="请输入正整数"
              >
                <template slot="prepend">建设奖励的代数：</template>
                <template slot="append">代</template>
              </el-input>
            </el-form-item>
            <el-form-item
              label=""
              prop="referral_bonus_extra_reward_money_rate"
            >
              <el-input
                type="number"
                max="100"
                v-model.number="form.referral_bonus_extra_reward_money_rate"
                placeholder="请输入1-100正整数"
              >
                <template slot="prepend">建设奖励 = 分享奖金 * </template>
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-row type="flex" justify="center">
              <el-form-item>
                <el-button
                  type="primary"
                  @click="saveConfigs"
                  :loading="btnLoading"
                >
                  保存
                </el-button>
              </el-form-item>
            </el-row>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (value > 100) {
            callback(new Error('值必须小于100'))
          } else {
            callback()
          }
        }
      }, 1000)
    }
    return {
      btnLoading: false,
      rules: {
        referral_bonus_extra_reward_money_gene_num: [
          { required: true, message: '请填写', trigger: 'change' },
          { type: 'number', message: '必须为数字值' },
        ],
        referral_bonus_extra_reward_money_rate: [
          { required: true, message: '请填写', trigger: 'change' },
          { type: 'number', message: '必须为数字值' },
          { validator: validatePass, trigger: 'blur' },
        ],
      },
      form: {
        referral_bonus_extra_reward_money_gene_num: '',
        referral_bonus_extra_reward_money_rate: '',
        configs: [],
      },
    }
  },
  mounted() {
    this.configs()
  },
  methods: {
    /** 鼠标移入cell */
    handleCellEnter(row, column, cell, event) {
      row.isEdit = true
    },
    /** 鼠标移出cell */
    handleCellLeave(row, column, cell, event) {
      row.isEdit = false
    },
    configs() {
      request({
        url: '/api/backend/rewardConfig/referralBonusConfigs',
        method: 'get',
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = {
            ...res.data,
            referral_bonus_extra_reward_money_gene_num: Number(
              res.data.referral_bonus_extra_reward_money_gene_num
            ),
            referral_bonus_extra_reward_money_rate: Number(
              res.data.referral_bonus_extra_reward_money_rate * 100
            ),
          }
          console.log(this.form)
        }
      })
    },

    saveConfigs() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/rewardConfig/saveReferralBonusConfigs',
            method: 'post',
            data: {
              referral_bonus_extra_reward_money_gene_num:
                this.form.referral_bonus_extra_reward_money_gene_num,
              referral_bonus_extra_reward_money_rate: Number(
                this.form.referral_bonus_extra_reward_money_rate / 100
              ),
              configs: this.form.configs,
            },
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
}
.text-center {
  text-align: center;
}
</style>
